import { Pipe, PipeTransform } from '@angular/core';

import {DefaultDataSchemaFriendlyNames} from '../../views/admin/application-settings/models/data-schema-name.model';

@Pipe({
    name: 'ngcDNamePipe'
})
export class DnamePipe implements PipeTransform {

    readonly NEW_DATA_SCHEMA = 'New Data Schema';

    transform(schemaName: string): any {
        if (schemaName) {
            if (schemaName !== this.NEW_DATA_SCHEMA) {
                const firstUnderscoreIndex = schemaName.indexOf('_');
                const lastUnderscoreIndex = schemaName.lastIndexOf('_');
                const dataSchemaName = schemaName.substring(firstUnderscoreIndex + 1, lastUnderscoreIndex).split('_').join(' ');
                return DefaultDataSchemaFriendlyNames[dataSchemaName] || dataSchemaName.split('_').join(' ');
            }
            return schemaName;
        }
        return '';
    }

}
